module.exports = __webpack_public_path__ + "img/affect-and-emotion.3fc17d1c.svg";